// Ported verbatim from native/src/editor/activity/plugins/challenge/HelloFriendFlow.js:149-162.

'use strict';

const {roleHasAnyBlock, totalBlockCount} = require('./helpers');

function evaluate (activityData, simState) {
    const bluuxHasFlag = roleHasAnyBlock(simState, 'bluux', ['onflag']);
    const bluuxHasSay = roleHasAnyBlock(simState, 'bluux', ['say']);
    const dogHasFlag = roleHasAnyBlock(simState, 'dog', ['onflag']);
    const dogHasSay = roleHasAnyBlock(simState, 'dog', ['say']);
    const success = bluuxHasFlag && bluuxHasSay && dogHasFlag && dogHasSay;

    return {
        success,
        usedBlocks: totalBlockCount(simState),
        storyPhase: simState && simState.phaseFlags && simState.phaseFlags.storyPhase || null,
        flagTapCount: simState && simState.phaseFlags && simState.phaseFlags.flagTapCount || 0
    };
}

module.exports = evaluate;
